import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAuth} from "../hooks/useAuth";
import Loading from "../../components/status/Loading";

interface PublicRouteProps {
    restricted?: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({restricted = false}) => {
    const {isAuthenticated, isLoading} = useAuth();
    const location = useLocation();

    if (isLoading) return <Loading/>;
    if (isAuthenticated && restricted) return <Navigate to="/" state={{from: location}}/>;

    return <Outlet/>;
}


export default PublicRoute;
